export const CASO_KEYS = {
    IdCuadroSede:   "IdCuadroSede",
    TipoCaso:       "TipoCaso",
    Tema:           "Tema",
    EstadoCaso:     "EstadoCaso",
    TipoReferencia: "TipoReferencia",
    Referencia:     "Referencia",
    ParametroValor:"ParametroValor",
    MensajeInicial: "MensajeInicial",
    IdReferenciaEntidad: "IdReferenciaEntidad", 
};

export const INIT_KEYS = {
    IdsTiposCaso: "IdsTiposCaso",
    IdsEstados:   "IdsEstados",
};

export const TIPO_CASOS = {
    CargaHoraria : "Carga Horaria",
    AlertaConfiguracion : "Alerta de Configuración",
    Nota: "Nota",
    Observacion: "Observación",
    SolicitudCambio: "Solicitud de Cambio"
}

export const TIPO_REFERENCIA = {
    Docente: "Docente",
    Colaborador: "Colaborador",
    Grado: "Grado",
    Bloque: "Bloque",
    Vacante: "Vacante"

}